import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BallotComponent } from './ballot/ballot.component';
import { PrintPageComponent } from './print-page/print-page.component';
import { VotingSuccessComponent } from './success-page/voting-success.component';
import { ReturnOptionsComponent } from './return-options/return-options.component';
import {
  ballotRoute,
  ballotListRoute,
  homeRoute,
  idUploadRoute,
  successRoute,
  welcomeRoute,
  sessionEndedRoute,
  declarationRoute,
  declinedRoute,
  reviewRoute,
  signatureRoute,
  headshotUploadRoute,
  registrationRoute,
  registrationSuccessRoute,
  surveyRoute,
  petitionRoute,
  returnOptionsRoute,
  printPageRoute,
  verifyMFARoute,
  passwordRoute,
  dashboardRoute,
  resetPasswordRoute,
  changePasswordRoute,
  scanQrRoute,
  manualOrgKeyRoute,
  verifyWithOrgKeyRoute,
  pollResultsRoute,
  pollDecisionRoute,
  pollResultsListRoute,
  changeMfaRoute,
  scanMfaQRroute
} from './route-names';
import { IdUploadComponent } from './id-upload/id-upload.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SessionEndedComponent } from './session-ended/session-ended.component';
import { BallotListComponent } from './ballot-list/ballot-list.component';
import { ReviewComponent } from './review/review.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { SignatureComponent } from './signature/signature.component';
import { HeadshotUploadComponent } from './headshot-upload/headshot-upload.component';
import { RegistrationComponent } from './registration/registration.component';
import { RegistrationSuccessComponent } from './registration-success/registration-success.component';
import { environment } from '../environments/environment';
import { VerifyVoterComponent } from './verify-voter/verify-voter.component';
import { DeclinedComponent } from './declined/declined.component';
import { CanActivateBallot } from './can-activate/can-activate-ballot';
import { CanActivateIDUpload } from './can-activate/can-activate-id-upload';
import { NeedsSession } from './can-activate/can-activate-needs-session';
import { CanActivateRegistrationSuccess } from './can-activate/can-activate-registration-success';
import { SessionService } from './Services/session.service';
import { ApiAboutService } from './Services/api-about.service';
import { SurveyComponent } from './survey/survey.component';
import { CanActivateRegistration } from './can-activate/can-activate-registration';
import { CanActivateElection } from './can-activate/can-activate-election';
import { PetitionComponent } from './petition/petition.component';
import { VerifyMfaComponent } from './verify-voter/verify-mfa.component';
import { CanActivateVerifyMFA } from './can-activate/can-activate-verifymfa';
import { PasswordComponent } from './verify-voter/password.component';
import { ResetPasswordComponent } from './verify-voter/reset-password/reset-password.component';
import { ChangePasswordComponent } from './user-menu/change-password/change-password.component';
import { QrScannerComponent } from './qr-scanner/qr-scanner.component';
import { OrgkeyManualComponent } from './orgkey-manual/orgkey-manual.component';
import { VerifyWithOrgComponent } from './verify-with-org/verify-with-org.component';
import { PollResultsComponent } from './dashboard/polls-panel/poll-results/poll-results.component';
import { PollResultsListComponent } from './dashboard/polls-panel/poll-results-list/poll-results-list.component';
import { PollComponent } from './dashboard/polls-panel/poll/poll.component';
import { ChangeMfaComponent } from './user-menu/change-mfa/change-mfa.component';
import { ScanMfaQrComponent } from './verify-voter/scan-mfa-qr/scan-mfa-qr.component';
import { CanActivateMfaQr } from './can-activate/can-activate-mfa-qr';

const routes: Routes = [
  { 
    path: homeRoute.join('/'), 
    component: VerifyVoterComponent,
    canActivate: [CanActivateElection] ,
    title: $localize`Identity Verification`
  },
  {
    path: ballotRoute.join('/'),
    component: BallotComponent,
    canActivate: [
      NeedsSession,
      CanActivateBallot,
    ],
    title: $localize`Ballot`
  },
  { 
    path: dashboardRoute.join('/'),
    component: BallotListComponent, // Contains the Dashboard Component
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Dashboard`
  },
  { 
    path: pollDecisionRoute.join('/'),
    component: PollComponent, 
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Poll`
  },
  { 
    path: pollResultsListRoute.join('/'),
    component: PollResultsListComponent, 
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Results List`
  },
  { 
    path: pollResultsRoute.join('/'),
    component: PollResultsComponent, 
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Results`
  },
  { 
    path: ballotListRoute.join('/'),
    component: BallotListComponent,
    canActivate: [
      NeedsSession,
      CanActivateBallot
    ],
    title: $localize`Ballots`
  },
  { 
    path: successRoute.join('/'),
    component: VotingSuccessComponent,
    canActivate: [
      NeedsSession,
      CanActivateBallot
    ],
    title: $localize`Success`
  },
  { 
    path: idUploadRoute.join('/'),
    component: IdUploadComponent,
    canActivate: [
      NeedsSession,
      CanActivateIDUpload,
    ],
    title: $localize`ID Verification`
  },
  {
    path: headshotUploadRoute.join('/'),
    component: HeadshotUploadComponent,
    canActivate: [
      NeedsSession,
    ],
    title: $localize`Facial Verification`
  },
  { path: welcomeRoute.join('/'), 
    component: WelcomeComponent,
    title: $localize`Welcome`
   },
  {
    path: sessionEndedRoute.join('/'),
    component: SessionEndedComponent,
    title: $localize`Session ended`
  },
  { 
    path: surveyRoute.join('/'), 
    component: SurveyComponent,
    canActivate: [CanActivateElection],
    title: $localize`Voluntary Survey`
  },
  { 
    path: reviewRoute.join('/'),
    component: ReviewComponent,
    canActivate: [
      NeedsSession,
      CanActivateBallot
    ],
    title: $localize`Review Ballot`
  },
  { 
    path: declarationRoute.join('/'),
    component: DeclarationComponent,
    canActivate: [NeedsSession],
    title: $localize`Declaration`
  },
  {
    path: declinedRoute.join('/'),
    component: DeclinedComponent,
    canActivate: [NeedsSession],
    title: $localize`Decline to vote`
  },
  { 
    path: signatureRoute.join('/'),
    component: SignatureComponent,
    canActivate: [
      NeedsSession,
      CanActivateBallot
    ],
    title: $localize`Affidavit`
  },
  { 
    path: registrationRoute.join('/'), 
    component: RegistrationComponent, 
    canActivate: [CanActivateRegistration],
    title: $localize`Registration`
  },
  { 
    path: registrationSuccessRoute.join('/'),
    component: RegistrationSuccessComponent,
    canActivate: [
      CanActivateRegistrationSuccess,
    ],
    title: $localize`Registration Success` 
  },
  { 
    path: returnOptionsRoute.join('/'),
    component: ReturnOptionsComponent,
    canActivate: [
      NeedsSession
    ],
    title: $localize`Return Options` 
  },
  { 
    path: petitionRoute.join('/'), 
    component: PetitionComponent,
    canActivate: [
      NeedsSession,
      CanActivateElection
    ],
    title: $localize`Petition`,
  },
  { 
    path: printPageRoute.join('/'),
    component: PrintPageComponent,
    canActivate: [
      NeedsSession
    ],
    title: $localize`Print`
  },
  {
    path: passwordRoute.join('/'),
    component: PasswordComponent,
    canActivate: [
      CanActivateElection,
      CanActivateIDUpload
    ],
    title: $localize`Password`
  },
  { 
    path: resetPasswordRoute.join('/'), 
    component: ResetPasswordComponent,
    canActivate: [
      CanActivateElection,
      CanActivateIDUpload
    ],
    title: $localize`Reset Password`,
  },
  {
    path: scanMfaQRroute.join('/'),
    component: ScanMfaQrComponent,
    canActivate: [
      CanActivateElection,
      CanActivateMfaQr
    ],
    title: $localize`Scan Authenticator QR`
  },
  {
    path: verifyMFARoute.join('/'),
    component: VerifyMfaComponent,
    canActivate: [
      CanActivateElection,
      CanActivateVerifyMFA
    ],
    title: $localize`Code`
  },
  { 
    path: changePasswordRoute.join('/'), 
    component: ChangePasswordComponent,
    canActivate: [
      NeedsSession
    ],
    title: $localize`Change Password`,
  },
  { 
    path: scanQrRoute.join('/'), 
    component: QrScannerComponent,
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Scan QR`,
  },
  { 
    path: manualOrgKeyRoute.join('/'), 
    component: OrgkeyManualComponent,
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Org Key`,
  },
  { 
    path:verifyWithOrgKeyRoute.join('/'), 
    component: VerifyWithOrgComponent,
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Verify with Org`,
  },
  { 
    path: changeMfaRoute.join('/'), 
    component: ChangeMfaComponent,
    canActivate: [
      NeedsSession,
      CanActivateIDUpload
    ],
    title: $localize`Change Multifactor Authentication`,
  },
  { path: '**', redirectTo: environment.startRoute.join('/') },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [
    NeedsSession,
    SessionService,
    CanActivateBallot,
    CanActivateElection,
    CanActivateIDUpload,
    CanActivateMfaQr,
    CanActivateRegistration,
    CanActivateRegistrationSuccess,
    CanActivateVerifyMFA,
    ApiAboutService,
  ]
})
export class AppRoutingModule { }
